import React from "react";

import { PersonModal } from "@molecules";
import { Text, Container } from "@atoms";

const StaffSection = ({ heading, copy, people }) => {
  return (
    <div className="my-12 sm:my-24">
      <Container variant="xxs" className="my-20">
        <h1 className="font-extended mb-6 text-center text-2xl text-blue">
          {heading}
        </h1>
        <div className="px-10">
          {copy && (
            <Text className="font-sans mt-6 text-center font-bold leading-tight">
              {copy}
            </Text>
          )}
        </div>
      </Container>
      <ul className="mt-6 grid grid-cols-2 gap-6 sm:mt-12 sm:grid-cols-3 lg:gap-y-12">
        {!!people?.length &&
          people?.map(p => (
            <li key={p.uid}>
              <PersonModal {...p} />
            </li>
          ))}
      </ul>
    </div>
  );
};

StaffSection.defaultProps = {};

export default StaffSection;
